/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgUserNameInfo } from './OrgUserNameInfo';
import {
    OrgUserNameInfoFromJSON,
    OrgUserNameInfoFromJSONTyped,
    OrgUserNameInfoToJSON,
    OrgUserNameInfoToJSONTyped,
} from './OrgUserNameInfo';

/**
 * 
 * @export
 * @interface OrganizationSalesSeatReductionPreviewResponse
 */
export interface OrganizationSalesSeatReductionPreviewResponse {
    /**
     * 
     * @type {Array<OrgUserNameInfo>}
     * @memberof OrganizationSalesSeatReductionPreviewResponse
     */
    ops_affected_users: Array<OrgUserNameInfo>;
    /**
     * 
     * @type {Array<OrgUserNameInfo>}
     * @memberof OrganizationSalesSeatReductionPreviewResponse
     */
    respond_affected_users: Array<OrgUserNameInfo>;
}

/**
 * Check if a given object implements the OrganizationSalesSeatReductionPreviewResponse interface.
 */
export function instanceOfOrganizationSalesSeatReductionPreviewResponse(value: object): value is OrganizationSalesSeatReductionPreviewResponse {
    if (!('ops_affected_users' in value) || value['ops_affected_users'] === undefined) return false;
    if (!('respond_affected_users' in value) || value['respond_affected_users'] === undefined) return false;
    return true;
}

export function OrganizationSalesSeatReductionPreviewResponseFromJSON(json: any): OrganizationSalesSeatReductionPreviewResponse {
    return OrganizationSalesSeatReductionPreviewResponseFromJSONTyped(json, false);
}

export function OrganizationSalesSeatReductionPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSalesSeatReductionPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ops_affected_users': ((json['ops_affected_users'] as Array<any>).map(OrgUserNameInfoFromJSON)),
        'respond_affected_users': ((json['respond_affected_users'] as Array<any>).map(OrgUserNameInfoFromJSON)),
    };
}

export function OrganizationSalesSeatReductionPreviewResponseToJSON(json: any): OrganizationSalesSeatReductionPreviewResponse {
    return OrganizationSalesSeatReductionPreviewResponseToJSONTyped(json, false);
}

export function OrganizationSalesSeatReductionPreviewResponseToJSONTyped(value?: OrganizationSalesSeatReductionPreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ops_affected_users': ((value['ops_affected_users'] as Array<any>).map(OrgUserNameInfoToJSON)),
        'respond_affected_users': ((value['respond_affected_users'] as Array<any>).map(OrgUserNameInfoToJSON)),
    };
}

